import $ from 'jquery';

$(() => {
	// =========================================== slick 관련: START ===========================================
	//banner_slider
	// Slick Scroll - banner_slider
	$(function () {
	    const bannerSlider = $(".banner_slider");

	    bannerSlider.on("wheel", function (e) {
			e.preventDefault();

			if (e.originalEvent.deltaY < 0) {
			  $(this).slick("slickNext");
			} else {
			  $(this).slick("slickPrev");
			}
	    });
	});
     
	 //table-accordion
	$(".fold-table tr.view").on("click", function(){
		$(this).toggleClass("open").next(".fold").toggleClass("open");
	});
	// ============================================ slick 관련: END ============================================
});
